import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import styles from './CustomHero.module.scss';

const CustomHero = ({
  className,
  overClassName,
  children,
  image,
  style,
  overlay,
}) => (
  <header
    className={styles.header + (className ? ' ' + className : '')}
    style={{
      backgroundImage: image && image.src ? `url(${image.src})` : null,
      ...style,
    }}
  >
    {image && image.fluid ? (
      <Img
        className={styles.thumbnail}
        fluid={image.fluid}
        alt={image.alt}
        style={{position: false}}
      />
    ) : null}

    {overlay !== false ? (
      <div className={styles.over + (overClassName ? ' ' + overClassName : '')}>
        <div className="wrap" style={{maxHeight: '100%'}}>
          {children}
        </div>
      </div>
    ) : null}
  </header>
);

CustomHero.propTypes = {
  children: PropTypes.node,
  image: PropTypes.object,
  style: PropTypes.object,
  overlay: PropTypes.bool,
};

export default CustomHero;
